import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import TokenIcon from '@mui/icons-material/Token';
import Layout from '../../components/Layout';
import BasicInfo from './basicInfo';
import InterestCharts from './interestChart';

import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import Box from '@mui/material/Box'; // Use MUI's Box
import BoxPlotChart from './boxPlotChart';
import ByNetworkChart from './byNetworkChart';

const Token = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const activeTab = urlParams.get('active_tab');

  let defaultTab = 'network-info';
  if (['network-info', 'interest-chart', 'box-plot', 'by-network'].includes(activeTab)) {
    defaultTab = activeTab;
  }


  const { symbol } = useParams();  
  const [tab, setTab] = useState(defaultTab);

  const handleTabChange = (event, newValue) => {
    // update url param to set the active tab
    const urlParams = new URLSearchParams(window.location.search);
    urlParams.set('active_tab', newValue);
    window.history.replaceState({}, '', `${window.location.pathname}?${urlParams}`);
    setTab(newValue);
  }

  return (
    <Layout title={`${symbol}`} icon={<TokenIcon />}>
      <TabContext value={tab}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <TabList onChange={handleTabChange} aria-label="simple tabs example">
            <Tab label="Network Info" value="network-info" />
            <Tab label="Interest Chart" value="interest-chart" />
            <Tab label="Box Plot" value="box-plot" />
            <Tab label="By Network" value="by-network" />
          </TabList>
        </Box>
        <TabPanel value="network-info">
          <BasicInfo symbol={symbol} />
        </TabPanel>
        <TabPanel value="interest-chart">
          <InterestCharts symbol={symbol} />
        </TabPanel>
        <TabPanel value="box-plot">
          <BoxPlotChart symbol={symbol} />
        </TabPanel>
        <TabPanel value="by-network">
          <ByNetworkChart symbol={symbol} />
        </TabPanel>
      </TabContext>
    </Layout>
  );
};

export default Token;
